import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/cn';

/**
 * Khối bề mặt có viền (§9.3.6).
 *
 * Dùng `rounded-lg` = 8px, vai trò `card` — **cùng** độ bo với `Tile`,
 * `PageHeader` và thanh điều hướng, vì cả bốn đều là panel lớp ngoài.
 *
 * Điểm không nhất quán Card-16px / Tile-24px mà §5.9 ghi nhận ở bản gốc biến
 * mất khi thống nhất về thang của antd (ADR-UI-0006).
 */
export function Card({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-lg border border-default bg-surface shadow-sm', className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('border-b border-default px-5 pb-3 pt-4', className)} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <h3 className={cn('text-sm font-semibold text-content-primary', className)}>{children}</h3>
  );
}

export function CardBody({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('p-5', className)} {...props}>
      {children}
    </div>
  );
}
